import { apiClient } from './api';
import type {
  BonusReward,
  MyReferrer,
  PendingReward,
  ClaimRewardsResult,
} from '@types';

export const referralService = {
  async getRefereesBonusRewards(): Promise<BonusReward[]> {
    const { data } = await apiClient.get<BonusReward[]>(
      '/api/v1/referral/referees/bonus-rewards'
    );
    return data;
  },

  async getMyReferrer(): Promise<MyReferrer | null> {
    const { data } = await apiClient.get<MyReferrer | null>(
      '/api/v1/referral/my-referrer'
    );
    return data;
  },

  async getPendingRewards(): Promise<PendingReward[]> {
    const { data } = await apiClient.get<PendingReward[]>(
      '/api/v1/referral/pending-rewards'
    );
    return data;
  },

  async claimAllRewards(): Promise<ClaimRewardsResult> {
    const { data } = await apiClient.post<ClaimRewardsResult>(
      '/api/v1/referral/claim-all'
    );
    return data;
  },

  async claimReward(rewardId: string): Promise<ClaimRewardsResult> {
    const { data } = await apiClient.post<ClaimRewardsResult>(
      `/api/v1/referral/claim/${rewardId}`
    );
    return data;
  },
};
